import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import WalletBalancingsTable from "containers/domain/wallet-balancing/WalletBalancingsTable";

const WalletBalancingsListingView = ({ match, tab }) => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Balanceamento da Carteira"
        content={<WalletBalancingsTable id={match.params.id} tab={tab} />}
      />
    </ItemGrid>
  </GridContainer>
);

export default WalletBalancingsListingView;
